import React from "react";
import { useNavigate } from "react-router-dom";
import { PRODUCT_CATEGORIES } from "../../../data/products";
import SectionHeader from "../../common/SectionHeader/SectionHeader";
import AnimatedSection from "../../common/AnimatedSection/AnimatedSection";
import Card, { CardBody, CardHeader } from "../../ui/Card/Card";
import "./ProductsSection.css";
import { useLanguage } from "../../../context/LanguageContext";

export const ProductsSection: React.FC = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  

  // Alt kategori isimlerini İngilizceye çeviren yardımcı fonksiyon
  const translateSubcategoryName = (sub: any): string => {
    const en: Record<string, string> = {
      'washing-machines': 'Washing Machines',
      'valve-grinding': 'Valve Grinding Machine',
      'crankshaft-grinding': 'Crankshaft Grinding Machine',
      'cylinder-head': 'Cylinder Head Seat Machining Machine',
      'honing-machines': 'Honing Machines',
      'main-bearing': 'Main Bearing and Connecting Rod Bush',
      'surface-grinding': 'Surface Grinding and Milling',
      'shim-grinding': 'Shim Grinding Machine',
      'equipment-parts': 'Equipment Spare Parts',
      'machine-parts': 'Machine Spare Parts',
      'diagnostic-tools': 'Diagnostic Tools',
      'tested-machines': 'Tested Machines',
    };
    const it: Record<string, string> = {
      'washing-machines': 'Macchine di lavaggio',
      'valve-grinding': 'Macchina rettifica valvole',
      'crankshaft-grinding': 'Rettifica albero motore',
      'cylinder-head': 'Macchina per sedi testata',
      'honing-machines': 'Macchine di honing',
      'main-bearing': 'Bronzine di banco e biella',
      'surface-grinding': 'Rettifica e fresatura superfici',
      'shim-grinding': 'Macchina rettifica spessori',
      'equipment-parts': 'Ricambi attrezzature',
      'machine-parts': 'Ricambi macchine',
      'diagnostic-tools': 'Strumenti diagnostici',
      'tested-machines': 'Macchine testate',
    };
    const ru: Record<string, string> = {
      'washing-machines': 'Мойки',
      'valve-grinding': 'Резьфиниш клапанов',
      'crankshaft-grinding': 'Шлифовка коленчатого вала',
      'cylinder-head': 'Обработка седел ГБЦ',
      'honing-machines': 'Хонинговальные станки',
      'main-bearing': 'Втулки коренные и шатунные',
      'surface-grinding': 'Фрезеровка и шлифовка поверхностей',
      'shim-grinding': 'Шлифовка шайб',
      'equipment-parts': 'Запчасти для оборудования',
      'machine-parts': 'Запчасти для станков',
      'diagnostic-tools': 'Диагностические инструменты',
      'tested-machines': 'Тестированные станки',
    };
    const map = language === 'it' ? it : language === 'ru' ? ru : en;
    return map[sub?.id] || sub?.name || sub?.title;
  };

  const handleViewProducts = (category: any) => {
    navigate(`/products?category=${category.id}`);
  };

  return (
    <section id="products" className="products">
      <div className="container">
        <AnimatedSection animation="fadeInUp" delay={0.2}>
          <SectionHeader
            subtitle={t('products.subtitle')}
            title={t('products.title')}
            description={t('products.desc')}
          />
        </AnimatedSection>

        <AnimatedSection animation="fadeInUp" delay={0.4} className="animated-section--staggered">
          <div className="products__grid">
            {PRODUCT_CATEGORIES.map((category, index) => (
              <div key={category.id} className="animated-section__item">
                <Card
                  variant="default"
                  hover
                  className="products__category-card"
                >
                  <CardHeader>
                    <div className="products__category-icon">
                      <i className="fas fa-cogs"></i>
                    </div>
                    {
                      (() => {
                        return (
                          <h3 className="products__category-title">{category.name}</h3>
                        );
                      })()
                    }
                  </CardHeader>

                  <CardBody>
                    {
                      (() => {
                        return (
                          <p className="products__category-description">{category.description}</p>
                        );
                      })()
                    }

                    <div className="products__subcategories">
                      {category.subcategories?.slice(0, 3).map((sub: any) => (
                        <div key={sub.id} className="products__subcategory">
                          <h4>{language === 'en' || language === 'it' ? translateSubcategoryName(sub) : sub.name}</h4>
                          <span className="products__count">
                            {(sub.products?.length || sub.count || 0)} {t('products.unit')}
                          </span>
                        </div>
                      )) || []}
                      {(category.subcategories?.length || 0) > 3 && (
                        <div className="products__more">
                          +{(category.subcategories?.length || 0) - 3} {t('products.moreCategories')}
                        </div>
                      )}
                    </div>

                    <button 
                      className="products__view-button btn-enhanced btn-pulse"
                      onClick={() => handleViewProducts(category)}
                    >
                      <span className="icon">
                        <i className="fas fa-images"></i>
                      </span>
                      {t('products.viewGallery')}
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
        </AnimatedSection>

        {/* Product Gallery is shown in dedicated Products page */}
      </div>
    </section>
  );
};

export default ProductsSection;
